import { createStyles } from 'antd-style';

/** useWorkspaceStyles 定义工作台壳层与侧栏展开、收起状态的样式。 */
export const useWorkspaceStyles = createStyles(({ css, token }) => ({
  layout: css`
    min-height: 100vh;
    background: ${token.colorBgContainer};
  `,
  sider: css`
    position: sticky !important;
    z-index: 10;
    inset-block-start: 0;
    height: 100vh;
    overflow: visible !important;
    border-inline-end: 1px solid ${token.colorBorderSecondary};
    background: #f2f0ef !important;
    /* 图文横排与竖排直接切换，避免侧栏缩放期间文字反复换行或被挤压。 */
    transition: none;

    .ant-layout-sider-children {
      overflow: visible;
    }
  `,
  siderInner: css`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-inline: 6px;
  `,
  brand: css`
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 10px;
    min-width: 0;
    padding: 16px 0 18px;
    overflow: hidden;
    white-space: nowrap;
  `,
  logo: css`
    display: block;
    width: 38px;
    height: 38px;
    flex: 0 0 auto;
    object-fit: contain;
  `,
  brandTitle: css`
    min-width: 0;
    flex: 1 1 0;
    overflow: hidden;
    font-size: 18px;
    font-weight: 800;
    line-height: 25px;
    text-overflow: ellipsis;
    background: linear-gradient(86.61deg, rgba(83, 55, 166, 0.9) -34.55%, rgba(0, 0, 0, 0.9) 122.6%);
    background-clip: text;
    color: transparent;
  `,
  menu: css`
    min-height: 0;
    flex: 1 1 auto;
    overflow: auto;
    border-inline-end: 0 !important;
    background: transparent !important;
    font-size: 14px;
    font-weight: 400;
    transition: none;

    .ant-menu-item {
      height: 54px;
      margin: 0;
      padding-inline: 14px !important;
      border-radius: 8px;
      color: ${token.colorTextTertiary};
      line-height: 54px;
      transition: background-color ${token.motionDurationMid}, color ${token.motionDurationMid};
    }

    .ant-menu-item .ant-menu-item-icon {
      min-width: 22px;
      font-size: 20px;
    }

    .ant-menu-item .ant-menu-item-icon,
    .ant-menu-item .ant-menu-title-content,
    .ant-menu-item .ant-menu-item-icon + .ant-menu-title-content {
      transition: none;
    }

    .ant-menu-item-selected {
      background: transparent !important;
      color: ${token.colorPrimary} !important;
    }

    .ant-menu-item:not(.ant-menu-item-selected):hover,
    .ant-menu-item:not(.ant-menu-item-selected):active {
      background: ${token.colorPrimaryBg} !important;
      color: ${token.colorTextSecondary} !important;
    }

    &.ant-menu-inline-collapsed {
      width: 52px;
    }

    &.ant-menu-inline-collapsed .ant-menu-item {
      display: flex;
      width: 52px;
      height: auto;
      min-height: 54px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 6px 0 !important;
      line-height: 1;
    }

    &.ant-menu-inline-collapsed .ant-menu-item .ant-menu-item-icon {
      flex: 0 0 auto;
      margin: 0;
      font-size: 20px;
      line-height: 22px;
    }

    /* 收起后仍需文字辨识入口，覆盖组件库默认的标题隐藏和横向图文间距。 */
    &.ant-menu-inline-collapsed .ant-menu-item .ant-menu-title-content {
      display: -webkit-box;
      width: 100%;
      flex: 0 0 auto;
      margin-inline-start: 0;
      overflow: hidden;
      font-size: 10px;
      line-height: 14px;
      text-align: center;
      white-space: normal;
      overflow-wrap: anywhere;
      opacity: 1;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  `,
  collapseToggle: css`
    position: absolute;
    z-index: 99;
    top: 50%;
    right: 0;
    display: flex;
    width: 20px;
    height: 30px;
    align-items: center;
    justify-content: center;
    padding: 0;
    transform: translate(50%, -50%);
    border: 0;
    border-radius: 21px;
    background: ${token.colorBgContainer};
    box-shadow: 0 4px 44px rgba(83, 55, 165, 0.04);
    cursor: pointer;
  `,
  collapseIcon: css`
    transition: transform 0.3s ease-in-out;
  `,
  collapseIconExpanded: css`
    transform: rotate(180deg);
  `,
  profile: css`
    flex: 0 0 auto;
    margin: 12px 0 44px;
    padding: 12px;
    border: 1px solid ${token.colorBorderSecondary};
    border-radius: 16px;
    background: #f7f6f5;
    box-shadow: 0 4px 44px rgba(77, 37, 196, 0.04);
  `,
  profileContent: css`
    display: flex;
    min-width: 0;
    align-items: center;
  `,
  profileAvatar: css`
    width: 32px !important;
    height: 32px !important;
    flex: 0 0 auto;
    border-radius: 8px !important;
  `,
  profileInfo: css`
    min-width: 0;
    flex: 1 1 0;
    margin-inline-start: 8px;
  `,
  profileName: css`
    overflow: hidden;
    color: ${token.colorText};
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  tenantName: css`
    overflow: hidden;
    color: ${token.colorTextTertiary};
    font-size: 12px;
    line-height: 16px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  profileFooter: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 16px;
  `,
  footerButton: css`
    display: inline-flex;
    width: 20px;
    height: 20px;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${token.colorText};
    cursor: pointer;
  `,
  noticeIcon: css`
    position: relative;
    display: inline-flex;
    width: 16px;
    height: 16px;
    color: ${token.colorText};
  `,
  noticeDot: css`
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ff4d4f;
    box-shadow: 0 0 0 2px #fff;
  `,
  collapsedProfile: css`
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    margin-bottom: 32px;
  `,
  collapsedAvatarButton: css`
    padding: 3px;
    border: 1px solid ${token.colorBgContainer};
    border-radius: 8px;
    background: #f7f8fc;
    box-shadow: 0 4px 44px rgba(83, 55, 166, 0.04);
    cursor: pointer;
  `,
  collapsedAvatar: css`
    width: 40px !important;
    height: 40px !important;
    border-radius: 6px !important;
  `,
  menuPopover: css`
    margin-inline-start: 12px;

    .ant-popover-inner {
      border: 1px solid ${token.colorBgContainer};
      border-radius: 8px;
      background: rgba(255, 255, 255, 0.82);
      box-shadow: 0 4px 44px rgba(77, 37, 196, 0.08);
      backdrop-filter: blur(8px);
    }
  `,
  personalMenu: css`
    width: 200px;
  `,
  personalLanguage: css`
    width: 100%;
    height: 52px;
    justify-content: flex-start;
    padding-inline: 8px;
    color: ${token.colorTextSecondary};

    &:hover {
      color: ${token.colorPrimary} !important;
    }
  `,
  personalMenuState: css`
    display: flex;
    min-height: 72px;
    align-items: center;
    justify-content: center;
    color: ${token.colorTextTertiary};
  `,
  personalMenuItem: css`
    box-sizing: border-box;
    display: flex;
    width: 100%;
    align-items: center;
    gap: 4px;
    padding: 16px 8px;
    border: 0;
    border-radius: 2px;
    background: transparent;
    color: ${token.colorTextSecondary};
    cursor: pointer;
    font: inherit;
    text-align: left;
    text-decoration: none;

    > svg:last-child {
      flex: 0 0 auto;
      margin-inline-start: auto;
    }

    &:hover {
      background: ${token.colorPrimaryBg};
      color: ${token.colorPrimary};
    }
  `,
  personalMenuIcon: css`
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  `,
  personalMenuTitle: css`
    min-width: 0;
    flex: 1 1 0;
    overflow: hidden;
    font-size: 14px;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  content: css`
    min-width: 0;
    padding: ${token.paddingXL}px;
    background: ${token.colorBgContainer};
  `,
  workspaceContent: css`
    height: 100vh;
    padding: 0;
    overflow: hidden;
  `,
  contentPanel: css`
    min-height: calc(100vh - ${token.paddingXL * 2}px);
    padding: ${token.paddingXL}px;
    border-radius: ${token.borderRadiusLG}px;
    background: ${token.colorBgContainer};
  `,
  workspacePanel: css`
    height: 100%;
    min-height: 0;
    padding: 0;
    border-radius: 0;
    overflow: hidden;
  `,
  entryGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: ${token.marginMD}px;
  `,
  entryCard: css`
    cursor: pointer;
    transition: transform ${token.motionDurationMid}, box-shadow ${token.motionDurationMid};

    &:hover {
      transform: translateY(-2px);
      box-shadow: ${token.boxShadowSecondary};
    }
  `,
  entryCardLink: css`
    display: block;
    color: inherit;
    text-decoration: none;

    &:focus-visible {
      border-radius: ${token.borderRadiusLG}px;
      outline: 2px solid ${token.colorPrimaryBorder};
      outline-offset: 2px;
    }
  `,
}));
